export default __webpack_public_path__ + "static/fifteen-mobile-ebd6a0c41eacfbb41f7f0f8d5a94b89d.svg";